export default __webpack_public_path__ + "static/media/Visual_joil_08.97ad2fbe.jpg";